module.exports = __webpack_public_path__ + "static/media/Avinita Shetty.a62dee86.png";